
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","version":"1.0","viewBox":"0 0 275 256"}, attrs),
              ...rest,
            },
            children.concat([_c('linearGradient',{attrs:{"id":"gradient","x1":"3.737","x2":"252.263","y1":"5.737","y2":"254.263","gradientTransform":"matrix(1 0 0 -1 0 258)","gradientUnits":"userSpaceOnUse"}},[_c('stop',{attrs:{"offset":"0","stop-color":"#2e2975"}}),_c('stop',{attrs:{"offset":"1","stop-color":"#f2295b"}})]),_c('path',{attrs:{"fill":"url(#gradient)","d":"M243.2 0H12.8C5.7 0 0 5.7 0 12.8v230.5c0 7 5.7 12.8 12.8 12.8h230.5c7 0 12.8-5.7 12.8-12.8V12.8C256 5.7 250.3 0 243.2 0zM93.9 184.9H71.1V71.1h22.8v113.8zm91 0h-68.2v-22.8H185l-.1 22.8zm0-45.5h-68.2v-22.8H185l-.1 22.8zm0-45.5h-68.2V71.1H185l-.1 22.8z"}})])
          )
        }
      }
    